import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class AddSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message: serverRes.message || 'Impossible de charger les coupons. Veuillez réessayer.',
        // ancien message: (serverRes.message || 'Erreur lors de la récupération') + ` Code d'erreur: ADS_ERR_${serverRes.statusCode || raw.status || '1000'}`
        data: null
      };
    }
    return {
      statuCode: 200,
      success: true,
      message: 'Ads got',
      data: (Array.isArray(serverRes?.data?.appInfo?.coupons)
        ? serverRes?.data?.appInfo?.coupons
        : []
      ).map((ad) => {
        return {
          id: ad.id,
          code: ad.code,
          pictureUrl: ad.pictureUrl,
          isPremium: ad.isPremium,
        };
      })
    };
  }

  serialize() {}
}

export const serializer = new AddSerializer();
